import React, { useState, useEffect, useContext } from 'react'

// styles for page
import './styles.css'

// components for page
import api from '../../services/api';
import SmallCard from '../smallCard/index'
import NavigationBar from '../navigationBar/index'
import errorHandlerShow from '../errorHandlerShow/index.js'
import StoreContext from '../../components/storage/context'
import AlertCustom from '../../components/alertCustom/index.js'
import SmallCardPlaceholder from '../../components/placeholders/smallCardPlaceholder'

// imagens
import image_process_design from '../../assets/diagrama_processo_arquivo_manual.svg'
import image_cadastro_tabela_cadastar from '../../assets/cadastro_tabela_cadastar.png'
import image_cadastro_tabela_campos from '../../assets/cadastro_tabela_campos.png'
import image_cadastro_tabela_modal from '../../assets/cadastro_tabela_modal.png'
import image_consulta_tabela from '../../assets/consulta_tabela.png'
import image_carregar_arquivo_tela from '../../assets/carregar_arquivo_tela.png'
import image_carregar_arquivo_modal from '../../assets/carregar_arquivo_modal.png'


const ManualFile = () => {
    const { pk_user, pk_service, token, setToken } = useContext(StoreContext);

    const [resources, setResources] = useState([])
    const [showAlert, setShowAlert] = useState(false)
    const [alert, setAlert] = useState({header: '', message: '', type: '', options_btn: []});

    const navegation = [
        {
            'nome': 'home',
            'link': '/'
        },
        {
            'nome': 'cadastro arquivos manuais',
            'link': `/cadastro-arq-manual?service_id=${pk_service}`
        }
    ]

    useEffect(() => {
        api.get('resources', {
            params: {'service_id': pk_service, 'pk_user': pk_user},
            headers: {'Authorization': token}
        }).then(response => {
            setResources(response.data);
        })
        .catch(error => {
            errorHandlerShow(error, setToken, setAlert, setShowAlert)
        })
    }, []);


    return (
        <div className="main-mf-container">
            <div className="main-mf-content">
                <AlertCustom showAlert={showAlert} setShowAlert={setShowAlert} alert={alert} />

                {/* Barra de navegação */}
                <NavigationBar navegation={navegation} />

                {/* Objetivo */}
                <div>
                    <h1 className="main-mf-title">Objetivo</h1>
                    <p className="main-mf-p"> A ingestão de Dados Manuais no Data Lake conta com um framework para que os proprietários de dados e usuários possam solicitar a inclusão desses dados no Data Lake para uso democrático dos dados.</p>
                </div>

                {/* Contexto */}
                <div>
                    <h1 className="main-mf-title">Contexto</h1>
                    <p className="main-mf-p">A equipe de governança de dados tem como missão acelerar a transformação digital de forma descomplicada, porém com responsabilidade. Sabemos da importância de MVP e time to marketing e entendemos que nem sempre os dados necessários para entrega de valor vêm de um sistema de forma automatizada. A governança para ingestão de dados manuais ao nosso Data Lake veio para solucionar a falsa dilema entre velocidade e controle. Se seu projeto precisa de ingestão de dados manuais, basta seguir o procedimento abaixo. É simples e prático.</p>
                    <p className="main-mf-p">A fim de facilitar o entendimento desse processo, nessa página você encontrará os seguintes itens:</p>
                    <ul className="main-mf-ul">
                      <li className="main-mf-li">O processo inteiro com as áreas envolvidas;</li>
                      <li className="main-mf-li">O passo a passo de como requerer a ingestão de arquivos manuais no Data Lake;</li>
                      <li className="main-mf-li">A opção de abrir uma solicitação ao time de Governança de Dados para cadastro do arquivo manual;</li>
                    </ul>
                </div>

                {/* Desenho do processo */}
                <div>
                  <h1 className="main-mf-title">Desenho do processo</h1>
                  <img className="main-mf-process-design" src={image_process_design} />
                </div>

                {/* Cadastrando uma tabela */}
                <div>
                  <h1 className="main-mf-title">Cadastrando uma tabela</h1>
                  
                  <p className="main-mf-p">Após a definição dos responsáveis, o primeiro passo é o cadastro da tabela. Para efetuar o cadastro, clique na opção "Cadastrar" na menu "Funções Habilitadas", ao final dessa documentação. Você será encaminhado para a seguinte tela:</p>
                  <img className="main-mf-images-default" src={image_cadastro_tabela_cadastar} />

                  <p className="main-mf-p">Após o preenchimento do formulário, você será encaminhado para a tela de cadastro dos campos da tabela.</p>
                  <img className="main-mf-images-default" src={image_cadastro_tabela_campos} />
                  
                  <p className="main-mf-p">Os campos podem ser adicionados clicando no botão "+ Campo". Para facilitar o cadatro, também há a opção de enviar um arquivo de exemplo, com os campos da tabela e alguns valores de exemplo. O arquivo deverá ter menos de 2MB. Caso o arquivo de exemplo seja maior que 2MB, recomendamos utilizar uma cópia do arquivo com apenas o cabeçalho e algumas poucas linhas.</p>
                  <p className="main-mf-p">O arquivo de exemplo deverá respeitar as mesmas regras que os arquivos com os dados da tabela que serão carregados posteriormente (amos separados por "," por exemplo).</p>
                  
                  <p className="main-mf-p">Após o carregamento do arquivo de exemplo, o preenchimento dos campos deverá ser completado até que todos constem como (y) na coluna "Status". Para completar o preenchimento dos campos, clique no botão editar (i) na coluna de ações. Caso deseje remover algum campo, clique no botão Remover (i), também na coluna Ações. O arquivo com os dados será validado durante o uplado, devendo conter o mesmo numéro e tipo de campos desse cadastro.</p>
                  <img className="main-mf-images-default" src={image_cadastro_tabela_modal} />
                </div>

                {/* Consultando uma tabela */}
                <div>
                  <h1 className="main-mf-title">Consultando uma tabela</h1>
                  
                  <p className="main-mf-p">Após efetuar o cadastro, a solicitação será encaminhada para aprovação (quanto tempo leva?). Para acompanhar o andamento da solicitação, clique na opção "Consultar" na menu "Funções Habilitadas"</p>
                  <p className="main-mf-p">Nessa tela você poderá consultar o status de aprovação e detalhes de cada uma das tabelas cadastradas.</p>
                  <img className="main-mf-images-default" src={image_consulta_tabela} />
                  
                  <p className="main-mf-p">Os valores da coluna "Status de Validação", podem ser:</p>
                  <ul className="main-mf-ul">
                    <li className="main-mf-li">Pendente: Aguardando a aprovação do time de Engenharia;</li>
                    <li className="main-mf-li">Aprovação final: Pronto para o upload dos arquivos;</li>
                    <li className="main-mf-li">Recusado: A solicitação foi recusada e o usuário receberá os motivos por e-mail;</li>
                  </ul>
                </div>

                {/* Carregando um arquivo */}
                <div>
                  <h1 className="main-mf-title">Carregando um arquivo</h1>
                  
                  <p className="main-mf-p">Após efetuar o cadastro e a tabela ter sido devidamente aprovada, basta fazer o carregamento do arquivo. Para fazer o uplado de um arquivo, clique na opção "Upload" na menu "Funções Habilitadas".Nessa tela você poderá fazer o upload dos arquivos para as tabelas. Caso a solicitação esteja como "Aprovação Final", basta clicar no botão "Upload" (i).</p>
                  <img className="main-mf-images-default" src={image_carregar_arquivo_tela} />
                  <img className="main-mf-images-default" src={image_carregar_arquivo_modal} />

                  <p className="main-mf-p">Após confirmar o envio, aparecerá uma mensagem de confirmação e você receberá um status do upload por email.</p>
                </div>

                {/* Precisa de ajuda? */}
                <div>
                    <h1 className="main-mf-title">Precisa de ajuda?</h1>
                    <p className="main-mf-p">O icone de ajuda, presente na barra superior do lado direito, possui informações úteis durante o cadastro de arquivos manuais. Se ainda assim persistirem dúvidas, entrar em contato com o time de governança de dados.</p>
                </div>

                {/* IMPORTANTE */}
                < br />
                <div>
                    <h1 className="main-mf-title">I M P O R T A N T E</h1>
                    <p className="main-mf-p">A mudança de layout durante o processo pode acarretar em falhas durante a execução. Assim sendo, a área solicitante será responsável em casos de falhas geradas pela situação aqui descrita.</p>
                </div>

                < br />

                {/* Funções habilitadas */}
                <div>
                    <p className="main-mf-title">Funções habilitadas</p>

                    <div className="main-mf-container-functions">
                        {resources.length <= 0 ?
                            [0, 1, 2].map(()=>(
                                <SmallCardPlaceholder />
                            ))
                        :
                            resources.map((item, index) => (
                                <SmallCard key={index} title={item.type_resource} color={item.color_hex} image={item.image_name} url={item.link_resource} />
                            ))
                        }
                    </div>
                </div>
            </div>
        </div>
    );
}

export default ManualFile;
